import { render, staticRenderFns } from "./projectplan.vue?vue&type=template&id=4fc574f5&"
import script from "./projectplan.vue?vue&type=script&lang=js&"
export * from "./projectplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports